import { ActionTypes } from '../actions/documents'

const initialState = {
  uploadStartTime: null,
}
export const documents = (state = initialState, action) => {
  if (action.type === ActionTypes.SET_DOCUMENT_UPLOAD_START_TIME) {
    return {
      ...state,
      uploadStartTime: action.startTime,
    }
  }
  return state
}

export default documents
